import { render, staticRenderFns } from "./PopupNew.vue?vue&type=template&id=1e966883&scoped=true&"
import script from "./PopupNew.vue?vue&type=script&lang=js&"
export * from "./PopupNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e966883",
  null
  
)

export default component.exports